/**
 * avatarSnapshot — cheap thumbnail source for body/face animation assets.
 *
 * The avatar viewport is already rendering full-quality on the main
 * canvas; we just snapshot it via `canvas.toDataURL`. One snapshot is
 * shared across every body/face card — same trick the existing
 * ClipsPanel uses. Refreshes on demand (e.g. when the avatar pose
 * changes or the user creates a new asset).
 *
 * Stored on window.__AVATAR_SNAPSHOT__ so AssetIcon and the Inspector
 * can read it without prop-drilling, matching the rest of the runtime's
 * `window.__*` debug-bridge convention.
 */

let _listeners = []

function notify() {
  for (const fn of _listeners) try { fn() } catch (e) { console.warn('[avatarSnapshot]', e) }
}

export function captureAvatarSnapshot() {
  if (typeof window === 'undefined') return null
  const canvas = window.__AVATAR_RENDERER__?.domElement
  if (!canvas) return null
  try {
    const dataUrl = canvas.toDataURL('image/jpeg', 0.7)
    window.__AVATAR_SNAPSHOT__ = dataUrl
    notify()
    return dataUrl
  } catch (e) {
    console.warn('[avatarSnapshot] toDataURL failed:', e)
    return null
  }
}

export function getAvatarSnapshot() {
  if (typeof window === 'undefined') return null
  return window.__AVATAR_SNAPSHOT__ ?? null
}

export function subscribeAvatarSnapshot(fn) {
  _listeners.push(fn)
  return () => { _listeners = _listeners.filter(l => l !== fn) }
}
